




































import { computed, defineComponent, PropType, toRef } from '@vue/composition-api';
import AppLogo from '@berlin-front/common/components/elements/AppLogo';
import AppText from '@berlin-front/common/components/elements/AppText';
import { bemx } from '@berlin-front/common/utils';
import { TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { HeaderType, HEADER_TYPE } from './composable';

export type ModalHeaderPropType = {
  headerType?: HeaderType;
  title?: string;
};

/**
 * ## ヘッダー
 *
 * 決済モジュールのヘッダー。ロゴとテキストで構成される。
 * タイトルのみ表示するシンプルなヘッダーと、ショップ情報を表示するヘッダーの2種類がある。
 * さらに、ショップ情報を表示するヘッダーはタイトル表示と合計金額表示の2種類がある。
 *
 */
export default defineComponent({
  name: 'ModalHeader',
  components: {
    AppLogo,
    AppText,
  },

  props: {
    /**
     * ヘッダー種別
     */
    headerType: {
      type: String as PropType<HeaderType>,
      default: HEADER_TYPE.TITLE_ONLY,
    },

    /**
     * 店舗名。
     */
    shopName: {
      type: String,
      default: '',
    },

    /**
     * 合計金額。
     * 数字だけでなく、未確定などの文字列も入る。
     */
    totalPrice: {
      type: String,
      default: '',
    },

    /**
     * 合計金額につける金額単位。
     * 円だけでなく円（未確定）などとつける場合もあることを考慮している。
     */
    totalPriceUnit: {
      type: String,
      default: '',
    },

    /**
     * ページタイトル
     */
    title: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const headerTypeRef = toRef(props, 'headerType');

    const isShop = computed(
      () => headerTypeRef.value === HEADER_TYPE.SHOP_TITLE || headerTypeRef.value === HEADER_TYPE.SHOP_PRICE,
    );
    const isShopTitle = computed(() => headerTypeRef.value === HEADER_TYPE.SHOP_TITLE);
    const isShopPrice = computed(() => headerTypeRef.value === HEADER_TYPE.SHOP_PRICE);
    const className = computed(() => bemx('ModalHeader', { empty: headerTypeRef.value === HEADER_TYPE.NONE }));

    return {
      className,
      isShop,
      isShopPrice,
      isShopTitle,
      text: {
        size: {
          body: TEXT_SIZE.BODY2,
          caption: TEXT_SIZE.CAPTION,
          heading: TEXT_SIZE.HEADING,
          heading6: TEXT_SIZE.HEADING6,
        },

        weight: {
          bold: TEXT_WEIGHT.WEIGHT700,
        },
      },
    };
  },
});
